const config = CSS_CONFIG || {};

export { config };
